<script setup lang="ts">
import { Ref, computed, ref } from 'vue';
import RexTooltipV3 from '@/rex-components/RexTooltipV3.vue';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons-vue';
import { useThemeToken } from '@/utils/theme/useThemeToken';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['onSortChange']);
const { t } = useI18n();
const { token } = useThemeToken();
const currState: Ref<boolean | null> = ref(null);

function onSortFieldClick() {
  currState.value =
    currState.value == null ? true : currState.value == true ? false : null;
  emit('onSortChange', currState.value);
}

const getAscIconColor = computed(() =>
  currState.value === true
    ? token.value?.colorPrimary
    : 'rgba(255, 255, 255, 0.7)',
);

const getDescIconColor = computed(() =>
  currState.value === false
    ? token.value?.colorPrimary
    : 'rgba(255, 255, 255, 0.7)',
);

const getTooltipText = computed(() => {
  return currState.value === true
    ? t('clickToSortDesc')
    : currState.value === false
      ? t('clickToCancelSorting')
      : t('clickToSortAsc');
});
</script>

<template>
  <RexTooltipV3
    :title="getTooltipText"
    :color="''"
    :overlayInnerStyle="{ fontSize: '0.85rem' }"
  >
    <div class="rex-sort-field-box" @click="onSortFieldClick">
      <CaretUpOutlined
        :style="{
          height: '0.55rem',
          color: getAscIconColor,
        }"
      />
      <CaretDownOutlined
        :style="{
          height: '0.55rem',
          color: getDescIconColor,
        }"
      />
    </div>
  </RexTooltipV3>
</template>

<style lang="scss" scoped>
.rex-sort-field-box {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
</style>
